import { render, staticRenderFns } from "./ModuleNewsTicker.vue?vue&type=template&id=993edd00&scoped=true"
import script from "./ModuleNewsTicker.vue?vue&type=script&lang=js"
export * from "./ModuleNewsTicker.vue?vue&type=script&lang=js"
import style0 from "./ModuleNewsTicker.vue?vue&type=style&index=0&id=993edd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993edd00",
  null
  
)

export default component.exports